const getObjectSelectedMock = ({ isAccount, isFacebook }) => ({
    objectSelected: {
        account_selected: {
            name: 'Pareto Group',
            selected: isAccount,
            content_type_name: isFacebook ? 'facebook_ads' : 'google_ads',
            content_type: 57,
            id: 3,
            currency_symbol: '',
        },
        client_selected: {
            name: 'Pareto',
            selected: !isAccount,
            content_type: 29,
            id: 1,
            currency_symbol: '',
        },
        loadingObjectSelected: false,
        isAccountSelected: isAccount,
    },
});

export default getObjectSelectedMock;
